import React from 'react';
import FlexAssignmentConfirmationModal from '../../FlexAssignmentConfirmationModal/FlexAssignmentConfirmationModal';
import FlexRequestShiftConfirmationModal from '../../FlexRequestShiftConfirmationModal/FlexRequestShiftConfirmationModal';

const BulkAssignConfirmation = ({
	isOpen,
	variant,
	unavailableDates,
	onConfirm,
	onCancel,
	isSubmitting,
	professionalLabel,
	facilityLabel,
	shiftsGroups,
	shiftStructures,
	currentFacilityUnits,
	facilityTimezone,
	showUnits
}) => {
	if (!isOpen) {
		return null;
	}

	if (variant === 'already-started-warning') {
		return (
			<FlexRequestShiftConfirmationModal
				title="Add assigned shifts? Shifts have started."
				textContent="One or more of the shifts you selected have already started. Do you want to continue?"
				boxTextContent={
					<>
						<strong>Reminder:</strong> Shift modifications must be made before their scheduled end time
					</>
				}
				primaryActionLabel="Continue"
				onPrimaryAction={onConfirm}
				secondaryActionLabel="Go back"
				onSecondaryAction={onCancel}
				onHide={onCancel}
				primaryActionDisabled={isSubmitting}
				secondaryActionDisabled={isSubmitting}
			/>
		);
	}

	return (
		<FlexAssignmentConfirmationModal
			title="Confirm Internal Flex assignment"
			professionalLabel={professionalLabel}
			facilityLabel={facilityLabel}
			shiftsGroups={shiftsGroups}
			shiftStructures={shiftStructures}
			currentFacilityUnits={currentFacilityUnits}
			facilityTimezone={facilityTimezone}
			unavailableDates={unavailableDates}
			showUnits={showUnits}
			onConfirm={onConfirm}
			onCancel={onCancel}
			confirmDisabled={isSubmitting}
			showLoadingSpinner={isSubmitting}
		/>
	);
};

export default BulkAssignConfirmation;
